// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".megamenu-enter-active[data-v-eda7c150],.megamenu-leave-active[data-v-eda7c150]{transition-duration:.3s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.megamenu-enter[data-v-eda7c150],.megamenu-leave-to[data-v-eda7c150]{opacity:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
